import { deviceInformation } from './device';

const isNonScrollableDevice = () => deviceInformation.isMobile;

const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;

const setHeaderWidthStyle = (value) => {
	const header = document.querySelector('.main-header-container');
	if (header) header.style.width = value;
};

export function lock(force = false, paddingFix = true) {
	if (!force && isNonScrollableDevice()) {
		return;
	}

	let attributes = 'overflow: hidden; -ms-touch-action: none; touch-action: none;';

	if (paddingFix) {
		attributes += ` padding-right: ${getScrollbarWidth()}px;`;
	}

	setHeaderWidthStyle(`calc(100% - ${getScrollbarWidth()}px)`);
	document.body.setAttribute('style', attributes);
}

export function unlock(force = false) {
	if (!force && isNonScrollableDevice()) {
		return;
	}

	setHeaderWidthStyle('100%');
	document.body.setAttribute('style', '');
}
